import GridLayout, { WidthProvider } from "react-grid-layout/legacy";
import "react-grid-layout/css/styles.css";
import { widgetMeta } from "@/lib/widgets";
import WidgetRenderer from "@/components/WidgetRenderer";
import { cn } from "@/lib/utils";

const RGL = WidthProvider(GridLayout);

export default function WorkspaceGrid({
  items,
  editMode,
  droppingType,
  onLayoutChange,
  onDropWidget,
  defaults,
  accounts,
  shareToken,
  onRemove,
  onSettingsChange,
  onDrill,
}) {
  const layout = items.map((it) => {
    const meta = widgetMeta(it.widget_type);
    return { i: it.i, x: it.x, y: it.y, w: it.w, h: it.h, minW: meta.minW, minH: meta.minH };
  });

  return (
    <div className={cn("rounded-2xl p-1", editMode && "canvas-dots")} data-testid="workspace-canvas" style={items.length === 0 ? { minHeight: 360 } : undefined}>
      <RGL
        className="layout"
        style={items.length === 0 ? { minHeight: 360 } : undefined}
        layout={layout}
        cols={12}
        rowHeight={64}
        margin={[12, 12]}
        containerPadding={[4, 4]}
        isDraggable={!!editMode}
        isResizable={!!editMode}
        draggableCancel=".no-drag"
        isDroppable={!!editMode}
        droppingItem={
          droppingType
            ? { i: "__drop__", w: widgetMeta(droppingType).w, h: widgetMeta(droppingType).h }
            : { i: "__drop__", w: 3, h: 2 }
        }
        onDrop={(l, layoutItem) => {
          if (droppingType && layoutItem) onDropWidget(droppingType, layoutItem.x, layoutItem.y);
        }}
        onLayoutChange={onLayoutChange}
        useCSSTransforms
      >
        {items.map((it) => (
          <div key={it.i}>
            <WidgetRenderer
              item={it}
              defaults={defaults}
              accounts={accounts}
              editMode={editMode}
              shareToken={shareToken}
              onRemove={onRemove}
              onSettingsChange={onSettingsChange}
              onDrill={onDrill}
            />
          </div>
        ))}
      </RGL>
    </div>
  );
}
